import { API_USERS_PATH } from '@shared/constants/pathsConstants';
import request from '@shared/api/request';

export function getAppUser() {
    return request.get(`/${API_USERS_PATH}/me/`);
}

export function getCsrfToken() {
    return request.get(`/csrf/`);
}

export function changeNotifyDestination(destination) {
    return request.patch(`/${API_USERS_PATH}/me/`, {
        notify_destination: destination,
    });
}
